





























































































































































































































import { Component, Vue, Emit, Ref, Watch } from 'vue-property-decorator'
import { Fornecedor, ProtocoloOPME } from '@/types/_'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { validateLength } from '@/utils/common'

@Component
export default class ComponentAlvoradaSolicitacaoCirurgiaProtocoloFornecedor extends Vue {
  $refs!: { formNovoFornecedor: any }
  novoFornecedorRules: any = {
    valid: false,
    fornecedorRules: [
      v => !!v || 'O campo Fornecedor é obrigatório.',
      v => validateLength(v, 3) || 'O campo Fornecedor deve ter pelo menos 3 caracteres.',
    ],
  }

  snack: any = { show: false, text: '', icon: '', color: '' }
  boxNovoFornecedor: boolean = false
  loader: boolean = false
  fornecedorDefault: Fornecedor = {
    fornecedorId: '',
    nome: '',
    opcao: 0,
    descricao: '',
    fabricante: '',
    disabled: false,
  }

  fornecedor: Fornecedor = { ...this.fornecedorDefault }
  fornecedor1: Fornecedor = { ...this.fornecedorDefault }
  fornecedor2: Fornecedor = { ...this.fornecedorDefault }
  fornecedor3: Fornecedor = { ...this.fornecedorDefault }

  errorFornecedor: string = ''
  errorFornecedor1: string = ''
  errorQuantidade: string = ''

  justificativa: string = ''

  fornecedores: Fornecedor[] = []

  @Watch('showModalProtocoloFornecedor')
  onChangeShowModalProtocoloFornecedor() {
    this.$nextTick(() => {
      if (this.$refs.formNovoFornecedor) this.$refs.formNovoFornecedor.reset()
    })
  }

  @Watch('addNovoFornecedor')
  onChangeAddNovoFornecedor() {
    this.$nextTick(() => {
      if (this.$refs.formNovoFornecedor) this.$refs.formNovoFornecedor.reset()
    })
  }

  get snackbar() {
    return this.snack
  }

  set snackbar(value: any) {
    this.snack = value
  }

  get loading() {
    return this.loader
  }

  set loading(value: boolean) {
    this.loader = value
  }

  get novoFornecedor() {
    return this.getSolicitacaoStore.novoFornecedor
  }

  get addNovoFornecedor() {
    return this.boxNovoFornecedor
  }

  set addNovoFornecedor(value: boolean) {
    this.boxNovoFornecedor = value
    if (value === false) {
      this.getSolicitacaoStore.clearNovoFornecedor()
      // this.$nextTick(() => this.$refs.formNovoFornecedor.reset())
    }
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getJustificativa() {
    return this.justificativa
  }

  set getJustificativa(value: string) {
    this.justificativa = value
  }

  get getFornecedor() {
    return this.fornecedor
  }

  set getFornecedor(value: Fornecedor) {
    this.fornecedor = value
  }

  get getFornecedores1() {
    return this.fornecedor1
  }

  set getFornecedores1(value: Fornecedor) {
    this.fornecedor1 = value
  }

  get getFornecedores2() {
    return this.fornecedor2
  }

  set getFornecedores2(value: Fornecedor) {
    this.fornecedor2 = value
  }

  get getFornecedores3() {
    return this.fornecedor3
  }

  set getFornecedores3(value: Fornecedor) {
    this.fornecedor3 = value
  }

  get getProtocoloOPMEsSelected() {
    return this.getSolicitacaoStore.protocoloOPMESelected
  }

  get getFornecedores() {
    return this.getSolicitacaoStore.fornecedores
  }

  set getFornecedores(value: Fornecedor[]) {
    this.getSolicitacaoStore.setFornecedores(value)
  }

  get getErrorFornecedor() {
    return this.errorFornecedor
  }

  set getErrorFornecedor(value: string) {
    this.errorFornecedor = value
  }

  get getErrorFornecedor1() {
    return this.errorFornecedor1
  }

  set getErrorFornecedor1(value: string) {
    this.errorFornecedor1 = value
  }

  get showModalProtocoloFornecedor() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showOpmeFornecedor
  }

  set showModalProtocoloFornecedor(value: boolean) {
    this.getSolicitacaoStore.setShowModalOpmeFornecedor(value)
    this.$nextTick(() => this.clearFornecedor())
  }

  get enableModalProtocolo() {
    return this.getSolicitacaoStore.enableModalProtocoloFornecedor
  }

  async salvarNovoFornecedor() {
    this.loading = true
    const response = await this.getSolicitacaoStore.salvarNovoFornecedor()

    if (response.success) {
      this.addNovoFornecedor = false
      this.snackbar = { show: true, text: `Fornecedor incluído com sucesso na lista! ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' }
    } else {
      this.addNovoFornecedor = false
      this.snackbar = { show: true, text: `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' }
    }
    this.loading = false
  }

  fornecedorItemDisabled() {
    const t: Fornecedor[] = []

    if (this.getFornecedores1.fornecedorId) {
      t.push(this.getFornecedores1)
    }

    if (this.getFornecedores2.fornecedorId) {
      t.push(this.getFornecedores2)
    }

    if (this.getFornecedores1.fornecedorId) {
      t.push(this.getFornecedores3)
    }

    this.getSolicitacaoStore.setFornecedorItemDisabled(t)
  }

  onlyNumber(input) {
    const numberPattern = /\d+/g
    const result = input.key.match(numberPattern)
    if (!result) {
      input.preventDefault()
      return false
    }
    return true
  }

  async isValid() {
    await this.getSolicitacaoStore.setProtocoloOPMEsValidate()
    let valid = true
    this.getProtocoloOPMEsSelected.opmes.map((p) => {
      const temp = p

      if (p.mensagem) {
        valid = false
      }

      return temp
    })

    if (this.getProtocoloOPMEsSelected.protocolo) {
      if (!this.getFornecedor.fornecedorId) {
        this.getErrorFornecedor = 'Por favor selecione fornecedor.'
        valid = false
      } else {
        this.getErrorFornecedor = ''
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (!this.getFornecedores1.fornecedorId) {
        this.getErrorFornecedor1 = 'Por favor selecione fornecedor.'
        valid = false
      } else {
        this.getErrorFornecedor1 = ''
      }
    }

    return valid
  }

  async save() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)
    const justificativa = this.getJustificativa

    if (await this.isValid()) {
      const protocoloOPME = this.getSolicitacaoStore.protocoloOPMESelected
      if (!protocoloOPME.protocolo) {
        protocoloOPME.opmes[0].justificativa = justificativa
      }
      await this.salvarOPME(protocoloOPME)
      this.getSolicitacaoStore.clearOpmeFornecedorSelected()
      await this.getSolicitacaoStore.getOpmeSearch('')
      this.showModalProtocoloFornecedor = false
      this.clearFornecedor()
    }
    this.clearLoadingRequest()
  }

  async updateFornecedor() {
    if (this.getSolicitacaoStore.protocoloOPMESelected.opmes.length > 0) {
      this.getJustificativa = this.getSolicitacaoStore.protocoloOPMESelected.opmes.length === 1
        ? this.getSolicitacaoStore.protocoloOPMESelected.opmes[0].justificativa
        : ''
      const { fornecedores } = this.getSolicitacaoStore.protocoloOPMESelected.opmes[0]

      if (
        !this.getSolicitacaoStore.protocoloOPMESelected.protocolo
        && this.getSolicitacaoStore.protocoloOPMESelected.opmes[0].id
        && fornecedores) {
        const fornecedoresSort = fornecedores.filter(c => c.opcao > 0).sort((c1, c2) => {
          if (c1.opcao >= c2.opcao) {
            return 1
          }

          if (c1.opcao <= c2.opcao) {
            return -1
          }

          return 0
        })

        for (let i = 0; i < fornecedoresSort.length; i++) {
          this[`getFornecedores${i + 1}`] = fornecedoresSort[i]
        }
      }
    }
  }

  async salvarOPME(protocoloOPME) {
    const { agrupamento, protocoloId } = protocoloOPME

    const protocolo = this.regraFornecedorOPME(protocoloOPME)

    for (let i = 0; i < protocolo.opmes.length; i++) {
      if (agrupamento) {
        protocolo.opmes[i].agrupamento = agrupamento
      }

      if (protocoloId) {
        protocolo.opmes[i].protocoloId = protocoloId
      }

      // eslint-disable-next-line
      const result: any = await this.getSolicitacaoStore.postOpme(protocolo.opmes[i])
      protocolo.opmes[i].id = result.id
    }

    this.getSolicitacaoStore.setProtocoloOPMEs(protocolo)
  }

  regraFornecedorOPME(protocoloOPME: ProtocoloOPME) {
    if (protocoloOPME.protocolo) {
      // eslint-disable-next-line
      protocoloOPME.opmes.map((opme) => {
      // eslint-disable-next-line
        opme.fornecedores = []
        opme.fornecedores.push(this.fornecedor)
      })

      this.fornecedor = { ...this.fornecedorDefault }
      return protocoloOPME
    }

    const fornecedoresTemp: Fornecedor[] = []

    const f1 = this.getFornecedores1
    f1.opcao = 1

    fornecedoresTemp.push(f1)

    if (!protocoloOPME.protocolo && this.getFornecedores2.fornecedorId) {
      const f2 = this.getFornecedores2
      f2.opcao = 2
      fornecedoresTemp.push(f2)
    }
    if (!protocoloOPME.protocolo && this.getFornecedores3.fornecedorId) {
      const f3 = this.getFornecedores3
      f3.opcao = 3
      fornecedoresTemp.push(f3)
    }

    protocoloOPME.opmes.map((c) => {
      const temp = c
      temp.fornecedores = fornecedoresTemp
      return temp
    })

    return protocoloOPME
  }

  clearFornecedor() {
    // if (this.$refs.formNovoFornecedor) this.$refs.formNovoFornecedor.reset()
    this.getFornecedor = { ...this.fornecedorDefault }
    this.getFornecedores1 = { ...this.fornecedorDefault }
    this.getFornecedores2 = { ...this.fornecedorDefault }
    this.getFornecedores3 = { ...this.fornecedorDefault }
    this.getJustificativa = ''
    this.addNovoFornecedor = false
    this.getSolicitacaoStore.clearNovoFornecedor()
    this.loading = false
  }

  clearFornecedorPosition(position: string) {
    this[`getFornecedores${position}`] = {
      fornecedorId: '',
      nome: '',
      opcao: 0,
      descricao: '',
      fabricante: '',
      disabled: false,
    }

    this.fornecedorItemDisabled()
  }

  updated() {
    this.fornecedorItemDisabled()
  }

  @Emit('addSelected')
  addSelected(value) {}

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }
}

